module.exports = __webpack_public_path__ + "img/cross.865629ed.svg";